module.exports = __webpack_public_path__ + "static/img/cop_sch_logo1.5b48336e.png";